import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from './breadcrumb.service';
import { HelpService } from '../../services/help.service';

@Component({
    selector: 'prox-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    standalone: false,
    styles: [`
        :host ::ng-deep .p-breadcrumb  {
          border: none !important;
          padding: 0 !important;
          margin-left: 0;
          margin-bottom: -5px;
        }
    `],
})
export class BreadcrumbComponent {
    items: MenuItem[] = [];
    home: MenuItem;

    constructor(
        public breadcrumbService: BreadcrumbService,
        public helpService: HelpService
    ) {
        this.home = { icon: 'pi pi-home', routerLink: '/' };
    }

    onShowHelp(): void {
        this.helpService.showHelp();
    }
}
